import React, {
  useState
} from 'react';
import {
  Link,
  useLocation
} from 'react-router-dom';
import '../../styles/navigation/AdminSidebar.css';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
  faAngleDoubleLeft,
  faHome,
  faUsers,
  faShip,
  faAddressBook,
  faTags,
  faStar,
  faNewspaper,
  faFolder,
  faBullhorn
} from '@fortawesome/free-solid-svg-icons';

const SidebarAdmin = () => {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <button className="sidebar__toggle-button" onClick={toggleSidebar}>
        <FontAwesomeIcon icon={faAngleDoubleLeft} />
      </button>

      <div className="sidebar__content">
        <ul className="sidebar__links">
          <li>
            <Link
              to="/admin"
              className={location.pathname === '/admin' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faHome} /> Home
            </Link>
          </li>

          <li>
            <Link
              to="/admin/users"
              className={location.pathname === '/admin/users' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faUsers} /> Customers
            </Link>
          </li>

          <li>
            <Link
              to="/admin/boats"
              className={location.pathname === '/admin/boats' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faShip} /> Boats
            </Link>
          </li>

          <li>
            <Link
              to="/admin/categories"
              className={location.pathname === '/admin/categories' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faTags} /> Categories
            </Link>
          </li>

          <li>
            <Link
              to="/admin/leads"
              className={location.pathname === '/admin/leads' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faAddressBook} /> Leads
            </Link>
          </li>

          <li>
            <Link
              to="/admin/reviews"
              className={location.pathname === '/admin/reviews' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faStar} /> Reviews
            </Link>
          </li>

          <li>
            <Link
              to="/admin/blog/posts"
              className={location.pathname === '/admin/blog/posts' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faNewspaper} /> Blog Posts
            </Link>
          </li>

          <li>
            <Link
              to="/admin/blog/categories"
              className={location.pathname === '/admin/blog/categories' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faFolder} /> Blog Categories
            </Link>
          </li>

          <li>
            <Link
              to="/admin/sales-popup"
              className={location.pathname === '/admin/sales-popup' ? 'active' : ''}
              onClick={() => setIsOpen(true)}
            >
              <FontAwesomeIcon icon={faBullhorn} /> Sales Popup
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SidebarAdmin;
